import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import EUserType from 'enums/userTypes';
import helpers from 'helpers';
import * as jose from 'jose';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';
import IGetTraderProfileResponse from 'services/httpClient/responses/auth/IGetTraderProfileResponse';

import { IApplicationState } from 'store/rootReducers';

import { authActions } from '../index';

function* refreshProfile({ payload }: PayloadAction<IApplicationState>) {
  try {
    if (!payload) {
      return;
    }
    const { authorization } = payload.auth;

    if (authorization.accessToken) {
      httpClient.defaults.headers.common.Authorization = `Bearer ${authorization.accessToken}`;

      const logInToken: jose.JaimyJWTPayload = jose.decodeJwt(
        authorization.accessToken,
      );
      if (!logInToken.rik_pp_access) {
        yield put(authActions.logoutRequest());
      }

      // Check if user is owner or worker
      if (logInToken.trader_id) {
        const { data }: AxiosResponse<IGetTraderProfileResponse> = yield call(
          httpClient.get,
          `/traders/v1/traders/${logInToken.trader_id}`,
        );

        const { data: interventionPartnershipData }: AxiosResponse = yield call(
          httpClient.get,
          `/backoffice/v1/intervention_partnerships/${
            data.rik_ip_id || data.b2b_ip_id
          }`,
        );

        data.role = EUserType.Owner;
        data.all_interventions = true;
        data.company_details = true;
        data.invoice_permission = true;
        data.user_management = true;
        data.trader_id = data.id;

        // set company address
        data.address = `${interventionPartnershipData.address.street} ${interventionPartnershipData.address.number}`;
        data.city = interventionPartnershipData.city;
        data.zip = interventionPartnershipData.zip;
        data.phone = interventionPartnershipData.phone;
        data.iban = (interventionPartnershipData.iban || data.iban).replaceAll(
          ' ',
          '',
        );

        yield put(authActions.setProfile(data));
      } else if (logInToken.worker_id) {
        // get worker info
        const { data }: AxiosResponse<IGetTraderProfileResponse> = yield call(
          httpClient.get,
          `/rik/v1/workers/${logInToken.worker_id}`,
        );

        const { data: interventionPartnershipData }: AxiosResponse = yield call(
          httpClient.get,
          `/backoffice/v1/intervention_partnerships/${data.intervention_partnership_id}`,
        );

        // check role of worker
        if (data.admin) {
          data.role = EUserType.Admin;
        } else if (data.accountant) {
          data.role = EUserType.Accountant;
        } else if (data.technician) {
          data.role = EUserType.Technician;
        }

        // set company address
        data.address = `${interventionPartnershipData.address.street} ${interventionPartnershipData.address.number}`;
        data.city = interventionPartnershipData.city;
        data.zip = interventionPartnershipData.zip;
        data.phone = interventionPartnershipData.phone;

        yield put(authActions.setProfile(data));
      }
    }
  } catch (err: any) {
    helpers.errorHandling(err);
  }
}

export default refreshProfile;
